import { renderSettingsCrossword } from "../Crossword";

const renderSettings = renderSettingsCrossword;

export default renderSettings;
